export enum productErrorTexts {
    TITLE = "Ой! Такой страницы на нашем сайте нет :(",
    DESCRIPTION = "Наверное, вы ошиблись при наборе адреса или перешли по неверной ссылке.",
    DESCRIPTION_ACTION = "Не расстраивайтесь, выход есть!",
    ACTION = "Перейдите на"
}